module.exports = __webpack_public_path__ + "media/assets/icons/icon_ins_life-ec8dfc3e5837452c483161f684f6aded.svg";